export default __webpack_public_path__ + "static/media/day.ca80219b.svg";